export default __webpack_public_path__ + "static/media/simon.26944244.png";